import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import './App.css';
import Home from './pages/Home';
import About from './pages/About';
import Products from './pages/Products';
import DehydratedAromatics from './pages/DehydratedAromatics';
import DryFruits from './pages/DryFruits';
import Cashews from './pages/Cashews';
import Almonds from './pages/Almonds';
import Walnuts from './pages/Walnuts';
import Pistachios from './pages/Pistachios';
import Raisins from './pages/Raisins';
import Figs from './pages/Figs';
import OtherDryFruits from './pages/OtherDryFruits';
import SpiceCatalogue from './pages/SpiceCatalogue';
import SpiceDetail from './pages/SpiceDetail';
import EdibleOilsCatalogue from './pages/EdibleOilsCatalogue';
import EdibleOilDetail from './pages/EdibleOilDetail';
import SugarCatalogue from './pages/SugarCatalogue';
import SugarDetail from './pages/SugarDetail';
import GrainsCatalogue from './pages/GrainsCatalogue';
import GrainDetail from './pages/GrainDetail';
import ProduceCatalogue from './pages/ProduceCatalogue';
import ProduceDetail from './pages/ProduceDetail';
import WellnessCatalogue from './pages/products/WellnessCatalogue';
import WellnessDetail from './pages/products/WellnessDetail';
import EximStack from './pages/EximStack';
import TraceabilityDossier from './pages/TraceabilityDossier';
import QAGates from './pages/QAGates';
import ExportPack from './pages/ExportPack';
import PublicTrace from './pages/PublicTrace';
import ShipmentTimeline from './pages/ShipmentTimeline';
import Analytics from './pages/Analytics';
import VerifiedDirectory from './pages/VerifiedDirectory';
import BuyerApplication from './pages/BuyerApplication';
import SellerApplication from './pages/SellerApplication';
import FarmerApplication from './pages/FarmerApplication';
import QualityCompliance from './pages/QualityCompliance';
import Markets from './pages/Markets';
import Gulfood from './pages/Gulfood';
import Contact from './pages/Contact';
import AdminLogin from './pages/AdminLogin';
import AdminDashboard from './pages/AdminDashboard';
// ORIVANA Fresh
import OrivanaFresh from './pages/orivana/OrivanaFresh';
import GrapesCatalogue from './pages/orivana/GrapesCatalogue';
import MangoesCatalogue from './pages/orivana/MangoesCatalogue';
import VegetablesCatalogue from './pages/orivana/VegetablesCatalogue';
import OnionsCatalogue from './pages/orivana/OnionsCatalogue';
import PomegranatesCatalogue from './pages/orivana/PomegranatesCatalogue';
import CitrusCatalogue from './pages/orivana/CitrusCatalogue';
import OrivanaEnquiry from './pages/orivana/OrivanaEnquiry';
import Layout from './components/Layout';
import { Toaster } from './components/ui/toaster';

function App() {
  return (
    <HelmetProvider>
    <div className="App">
      <BrowserRouter>
        <Layout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/products" element={<Products />} />
            <Route path="/products/dehydrated-aromatics" element={<DehydratedAromatics />} />
            <Route path="/products/dry-fruits" element={<DryFruits />} />
            <Route path="/products/dry-fruits/cashews" element={<Cashews />} />
            <Route path="/products/dry-fruits/almonds" element={<Almonds />} />
            <Route path="/products/dry-fruits/walnuts" element={<Walnuts />} />
            <Route path="/products/dry-fruits/pistachios" element={<Pistachios />} />
            <Route path="/products/dry-fruits/raisins" element={<Raisins />} />
            <Route path="/products/dry-fruits/figs" element={<Figs />} />
            <Route path="/products/dry-fruits/other" element={<OtherDryFruits />} />
            <Route path="/products/spices" element={<SpiceCatalogue />} />
            <Route path="/products/spices/:spiceId" element={<SpiceDetail />} />
            <Route path="/products/edible-oils" element={<EdibleOilsCatalogue />} />
            <Route path="/products/edible-oils/:oilId" element={<EdibleOilDetail />} />
            <Route path="/products/sugar" element={<SugarCatalogue />} />
            <Route path="/products/sugar/:sugarId" element={<SugarDetail />} />
            <Route path="/products/grains" element={<GrainsCatalogue />} />
            <Route path="/products/grains/:grainId" element={<GrainDetail />} />
            <Route path="/products/produce" element={<ProduceCatalogue />} />
            <Route path="/products/produce/:produceId" element={<ProduceDetail />} />
            <Route path="/products/wellness" element={<WellnessCatalogue />} />
            <Route path="/products/wellness/:slug" element={<WellnessDetail />} />
            {/* ORIVANA Fresh Routes */}
            <Route path="/products/orivana-fresh" element={<OrivanaFresh />} />
            <Route path="/products/orivana-fresh/grapes" element={<GrapesCatalogue />} />
            <Route path="/products/orivana-fresh/mangoes" element={<MangoesCatalogue />} />
            <Route path="/products/orivana-fresh/vegetables" element={<VegetablesCatalogue />} />
            <Route path="/products/orivana-fresh/onions" element={<OnionsCatalogue />} />
            <Route path="/products/orivana-fresh/pomegranates" element={<PomegranatesCatalogue />} />
            <Route path="/products/orivana-fresh/citrus" element={<CitrusCatalogue />} />
            <Route path="/products/orivana-fresh/enquiry" element={<OrivanaEnquiry />} />
            <Route path="/eximstack" element={<EximStack />} />
            <Route path="/eximstack/traceability" element={<TraceabilityDossier />} />
            <Route path="/eximstack/traceability/:id" element={<TraceabilityDossier />} />
            <Route path="/eximstack/qa-gates" element={<QAGates />} />
            <Route path="/eximstack/qa-gates/:id" element={<QAGates />} />
            <Route path="/eximstack/export-pack" element={<ExportPack />} />
            <Route path="/eximstack/export-pack/:id" element={<ExportPack />} />
            <Route path="/trace/:batchId" element={<PublicTrace />} />
            <Route path="/shipment/:id" element={<ShipmentTimeline />} />
            <Route path="/analytics" element={<Analytics />} />
            <Route path="/verified-directory" element={<VerifiedDirectory />} />
            <Route path="/verified-directory/apply-buyer" element={<BuyerApplication />} />
            <Route path="/verified-directory/apply-seller" element={<SellerApplication />} />
            <Route path="/verified-directory/apply-farmer" element={<FarmerApplication />} />
            <Route path="/quality-compliance" element={<QualityCompliance />} />
            <Route path="/markets" element={<Markets />} />
            <Route path="/gulfood" element={<Gulfood />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminDashboard />} />
          </Routes>
        </Layout>
        <Toaster />
      </BrowserRouter>
    </div>
    </HelmetProvider>
  );
}

export default App;
